export default __webpack_public_path__ + "static/media/tv-white.1d52dbfe.svg";